module.exports = __webpack_public_path__ + "static/img/sl04.ed04d9103.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/sl04.png
// module id = Fpkl
// module chunks = 0